export default {
  wrapper: {
    my: [4, 5],
    px: [3, 4],
    py: [4, 5],
    bg: 'muted',
    borderRadius: 8,
  },
  title: {
    mb: 3,
  },
  message: {
    fontSize: 2,
    color: 'text',
  },
};
